import { render, staticRenderFns } from "./WarehouseManagerForm.vue?vue&type=template&id=48156ba0&"
import script from "./WarehouseManagerForm.vue?vue&type=script&lang=ts&"
export * from "./WarehouseManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports